import React from "react";

const SvgLibra = (props) => {
  return (
    <svg
      viewBox="0 0 46.05 26.25"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M44.55 17.09h-10.2a1.498 1.498 0 01-1.5-1.5c0-.1.01-.21.03-.32.15-.72.23-1.44.23-2.15C33.12 7.54 28.58 3 23 3S12.88 7.54 12.88 13.12c0 .7.08 1.43.23 2.15.02.1.03.21.03.31a1.5 1.5 0 01-1.5 1.5H1.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h8.41c-.02-.32-.04-.64-.04-.96C9.88 5.89 15.76 0 23 0s13.12 5.89 13.12 13.12c0 .32-.01.64-.04.96h8.46c.83 0 1.5.67 1.5 1.5s-.66 1.51-1.49 1.51m0 9.16H1.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h43.05c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default SvgLibra;
